export default __webpack_public_path__ + "static/media/timer_background_l1.0f7d4a63.jpg";